import * as React from "react";
import styled from "styled-components";
import {
  ConstBorderRound,
  ConstColor,
  ConstFontStyle,
  ConstPadding,
} from "../../../../config/styles_const/styles_const";
import Assets from "../../../assets/img/assets";

interface IProps
  extends React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {}

const SelectDefault: React.FC<IProps> = (props) => {
  const { children, placeholder, ...InputProps } = props;

  return <select {...InputProps}>{children}</select>;
};

const FormSelect = styled(SelectDefault)`
  appearance: none;
  -ms-expand {
    display: none;
  }

  width: 100%;
  padding: ${ConstPadding.FormDefaultPadding};
  // border
  border: 1px solid ${ConstColor.Gray};
  box-sizing: border-box;
  border-radius: ${ConstBorderRound.CornerRoundAll};
  // font
  font-style: normal;
  font-weight: ${ConstFontStyle.FormDefault.fontWeight};
  font-size: ${ConstFontStyle.FormDefault.fontSize};
  line-height: ${ConstFontStyle.FormDefault.lineHeight};
  background-color: ${ConstColor.White};
  &:focus {
    outline: 0;
    border: 1px solid ${ConstColor.Focus};
  }
  &:disabled {
    background: ${ConstColor.Readonly};
    border: 1px solid ${ConstColor.Readonly};
  }
  color: ${ConstColor.Base};

  // 矢印
  background-image: url(${Assets.polygon});
  background-repeat: no-repeat;
  background-size: 12px 6px;
  background-position: right 10px center;
`;

export default FormSelect;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/form/form_select.tsx